import {
  GET_SESSION_SUCCESS,
  GET_SESSION_ERROR,
  GET_USER_SESSION_SUCCESS,
  GET_USER_SESSION_ERROR,
  INVALID_SESSION,
} from './types';

export const getSessionSuccess = () => ({ type: GET_SESSION_SUCCESS });

export const getSessionError = () => ({ type: GET_SESSION_ERROR });

export const getUserSessionSuccess = (user) => ({
  user,
  type: GET_USER_SESSION_SUCCESS,
});

export const getUserSessionError = () => ({ type: GET_USER_SESSION_ERROR });

export const invalidSession = () => ({ type: INVALID_SESSION });
